import React from 'react';

import { formatPrice } from '../../../data/helpers';

import { PriceWrapper, CurrentPrice, OriginalPrice, DiscountBadge } from './styles';

export default function PriceTag({ amount, originalAmount }) {
  const hasDiscount = originalAmount && originalAmount > amount;
  const discountPercent = hasDiscount
    ? Math.round(((originalAmount - amount) / originalAmount) * 100)
    : 0;

  return (
    <PriceWrapper>
      <CurrentPrice>{formatPrice(amount)}</CurrentPrice>
      {hasDiscount && (
        <>
          <OriginalPrice>{formatPrice(originalAmount)}</OriginalPrice>
          <DiscountBadge>-{discountPercent}%</DiscountBadge>
        </>
      )}
    </PriceWrapper>
  );
}
